import React, { useEffect } from "react";

const FacebookChat = () => {
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        xfbml: true,
        version: "v10.0",
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  return (
    <div
      className="fb-customerchat"
      attribution="setup_tool"
      page_id="719486016589700"
      greeting_dialog_display="hide"
      greeting_dialog_delay="30"
      minimized="true"
      theme_color="#0084ff"
    ></div>
  );
};

export default FacebookChat;
